import { render, staticRenderFns } from "./ThingsToNote.vue?vue&type=template&id=45462f1a&"
import script from "./ThingsToNote.vue?vue&type=script&lang=js&"
export * from "./ThingsToNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports